export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M2 10v2h12v-2zm0-4v2h12V6zm8 10v-2H2v2zm13-3-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z\"/>"
};